import { createSlice } from '@reduxjs/toolkit';

type ISidebarData = {
    show: boolean;
};

const initialState: ISidebarData = {
    show: false,
};

const sidebarSlice = createSlice({
    name: 'sidebar',
    initialState: initialState,
    reducers: {
        open(state) {
            state.show = true;
        },
        close(state) {
            state.show = false;
        },
    },
});

export const sidebarActions = sidebarSlice.actions;

export default sidebarSlice;
